import React, { useMemo } from "react"

import Text from "components/article/text"
import RecipeOverview from "./recipe-overview"
import RecipeIngredients from "./recipe-ingredients"
import RecipeSteps from "./recipe-steps"

const Recipe = ({ article, element }) => {
  const { recipes } = article

  if (!recipes) {
    return null
  }

  const { recipeId } = element

  const recipeData = useMemo(() => {
    const recipe = recipes.find((r) => r.id === recipeId)

    return {
      ...recipe,
      prepTimeMinutes: recipe.prepTimeMinutes || 0,
      cookTimeMinutes: recipe.cookTimeMinutes || 0,
      servings: recipe.yield,
    }
  }, [recipes, recipeId])

  const renderElement = (item) => {
    switch (item.type) {
      case "recipeIngredients":
        return <RecipeIngredients ingredients={item} />
      case "recipeSteps":
        return <RecipeSteps steps={item} />
      case "recipeNotes":
        return <Text element={item} />
      default:
        return null
    }
  }

  return recipeData ? (
    <>
      <RecipeOverview {...recipeData} />
      {recipeData.body.map((item) => renderElement(item))}
    </>
  ) : null
}

export default Recipe
